import { useMutation, useQuery } from '@tanstack/react-query';
import api from '@api/http/api';

interface Capsule {
  id: number;
  type: string;
  endsAt: string;
  user: {
    username: string;
    id: number;
  };
};

export function useActivateCapsuleMutation() {
  return useMutation<{ success: true }, {}, { id: number }>({
    mutationFn: (values) => api.post('/capsules/activate', values),
  });
}

export function useFreeZenithMutation() {
  return useMutation<{ success: true }, {}, { url: string }>({
    mutationFn: (values) => api.post('/capsules/free', values),
  });
}

export function useCapsulesQuery() {
  return useQuery<Capsule[]>({
    queryFn: () => api.get('/capsules'),
    queryKey: ['capsules'],
  });
}
